import * as z from "zod";
import { requiredString, requiredNumber } from "components/form/utils";

export const clientSchema = z.object({
  first_name: requiredString(),
  last_name: requiredString(),
  // client_id: z.string(),
  mobile_number: z.string().optional().nullable(),
  email: z
    .string()
    .email("Invalid email format")
    .optional()
    .or(z.literal(""))
    .nullable(),
  company_id: requiredString(),
  notes: z.string().optional().nullable(),
  about: z.string().optional().nullable(),
  code: requiredString()
    .length(4, "Code must be exactly 4 characters")
    .transform((v) => (typeof v === "string" ? v.toUpperCase() : v)),
  billable_due_days: requiredNumber(),
});
